import React from "react";
import { Link } from "react-router-dom";
import Image from "../../assets/image";
const NewLogo = () => {
  return (
    <Link to="/">
      <img
        className="w-16 h-16 sm:w-[72px] sm:h-[72px] lg:w-[120px] lg:h-[120px]"
        src={Image?.newlogo}
        alt="Logo"
      />
    </Link>
  );
};
export default NewLogo;
